import React, { Component } from "react";
import Header from "./Header";
import App from "..//App";

export default class Admin extends Component {
  render() {
    function adminDrawing() {
    
      document.getElementsByClassName("header-link").innerHTML = "1111";
      console.log();
    }
    adminDrawing();
    return (
      <>
        <Header />
        <App />
      </>
    );
  }
}
